import Modal from 'react-responsive-modal';
import alert from '../../../../assets/images/alert.png';
import { Button } from '../../../../components/Button';
import styles from './style.module.css';
import { useAuth } from '../../../../hooks/useAuth';

interface IModalUserExists {
  modalIsOpen: boolean;
  toggleModal: () => void;
  generateNewEmail: () => void;
  restorePassword: () => void;
  newDataRegistration: boolean;
  message: string;
}

export function ModalUserExists({
  modalIsOpen,
  toggleModal,
  generateNewEmail,
  restorePassword,
  newDataRegistration,
  message,
}: IModalUserExists) {
  const { client } = useAuth();

  return (
    <Modal open={modalIsOpen} onClose={toggleModal} center>
      <div className="contents-modal">
        <div className="d-flex justify-content-center">
          <img className={styles.alert} src={alert} alt="" />
        </div>
        <h1 className="title-modal">Aviso</h1>
        <p className="subtitle-modal">{message}</p>
      </div>
      <div className={styles.contentBtn}>
        {newDataRegistration ? (
          <>
            <Button
              isModal
              text="Prosseguir"
              type="button"
              color="primary"
              onClick={generateNewEmail}
            />
            <Button
              isModal
              text="Cancelar"
              type="button"
              color="flat"
              onClick={toggleModal}
            />
          </>
        ) : (
          <>
            <Button
              isModal
              text="Faça seu LOGIN"
              type="button"
              color="flat"
              onClick={() => {
                location.href = `/_/${client.clientUrl}`;
              }}
            />
            <Button
              isModal
              text="Recupere a sua senha"
              type="button"
              color="primary"
              onClick={() => {
                restorePassword();
                toggleModal();
              }}
            />
          </>
        )}
      </div>
    </Modal>
  );
}
